
import SchoolIcon from '@mui/icons-material/School';

const Universities = () => (
    <div className="mt-5 mb-5">
        <p className="text-white text-[17px] font-semibold"> Formación Academica </p>
        <ol className="relative border-s-[2px] border-gris mt-4" >
            <li className="mb-10 ms-6">
                <span className="absolute flex items-center justify-center w-6 h-6  rounded-full -start-3 ring-8 ring-gris bg-negro_alt">
                    <SchoolIcon className="text-amarillo" sx={{ fontSize: 14 }} />
                </span>
                <div className="p-4 rounded-lg shadow-xs  bg-gris_alt border-gray-600">
                   
                    <div className="flex justify-between items-start">
                        <div>
                            <p className="text-white text-md font-semibold">Maestría en Sistemas Computacionales</p>
                            <p className="text-white text-sm font-semibold">Instituto Tecnológico de Acapulco</p>
                        </div>
                        <p className="text-main text-xs font-semibold">2021-2023 </p>
                    </div>

                    <p className="text-main text-sm"> Acapulco de Juárez, Guerrero </p>
                </div>
            </li>

            <li className="ms-6">
                <span className="absolute flex items-center justify-center w-6 h-6  rounded-full -start-3 ring-8 ring-gris bg-negro_alt">
                    <SchoolIcon className="text-amarillo" sx={{ fontSize: 14 }} />
                </span>
                <div className="p-4 rounded-lg shadow-xs  bg-gris_alt border-gray-600">
                    <div className="flex justify-between items-start">
                        <div>
                            <p className="text-white text-md font-semibold">Ingeniería en Sistemas Computacionales</p>
                            <p className="text-white text-sm font-semibold">Instituto Tecnológico de Acapulco</p>
                        </div>
                        <p className="text-main text-xs font-semibold">2014-2019 </p>
                    </div>

                    <p className="text-main text-sm"> Acapulco de Juárez, Guerrero </p>
                </div>
            </li>
        </ol>
    </div>
);

export default Universities;
